import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutWirecodeLookup extends Layout {
    sourceWirecodesForUser: DataSource;
    tableWireCodeLookup: Table;
}
